export const YouTubeEmbed = () => {
    document.addEventListener("DOMContentLoaded",
        function () {
            const youTubeContainers = document.querySelectorAll('.youtube-player');

            if (youTubeContainers.length > 0) {
                youTubeContainers.forEach(item => {
                    const div = document.createElement("div");
                    const poster = item.dataset.poster ?? false;
                    div.setAttribute("data-id", item.dataset.id);
                    if (poster) {
                        div.innerHTML = posterImage(item.dataset.id, poster);
                    } else {
                        div.innerHTML = thumb(item.dataset.id);
                    }

                    item.appendChild(div);
                    div.addEventListener('click', () => {
                        iframe(div);
                        item.classList.add('responsive-embed');
                    })
                });
            }

        });


    function posterImage(id, posterImg) {
        const thumb = `<div class="youtube-player__poster" style="background-image: url(${posterImg})">`,
            play = '<div class="play"></div>';
        return thumb + play;
    }

    function thumb(id) {
        const thumb = '<div class="youtube-player__poster" style="background-image: url(https://i.ytimg.com/vi/ID/maxresdefault.jpg)">',
            play = '<div class="play"></div>';
        return thumb.replace("ID", id) + play;
    }

    function iframe(item) {
        const iframe = document.createElement("iframe");
        const embed = "https://www.youtube.com/embed/ID?autoplay=1";
        iframe.setAttribute("src", embed.replace("ID", item.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        iframe.classList.add('w-full', 'aspect-video', 'rounded-lg', 'shadow-lg')
        item.parentNode.replaceChild(iframe, item);

    }
};